import { Button as MuiButton } from '@mui/material';
import { shouldNotForwardProps } from '../../helpers';
import { styled } from '../muiReexports';
export const MuiButtonStyled = styled(MuiButton, shouldNotForwardProps('float'))(({ float }) => ({
    ...(float === 'right' && {
        marginLeft: 'auto',
    }),
    ...(float === 'left' && {
        marginRight: 'auto',
    }),
}));
